export const awards = {
	AWARD_LIST: "AWARD_LIST",
	AWARD_LIST_SET_DATA: "AWARD_LIST_SET_DATA",
	AWARD_LIST_SET_ERROR: "AWARD_LIST_SET_ERROR",
	AWARD_LIST_IS_FETCHING: "AWARD_LIST_IS_FETCHING",

	AWARD_LIST_SUMMARY: "AWARD_LIST_SUMMARY",
	AWARD_LIST_SUMMARY_SET_DATA: "AWARD_LIST_SUMMARY_SET_DATA",
	AWARD_LIST_SUMMARY_SET_ERROR: "AWARD_LIST_SUMMARY_SET_ERROR",
	AWARD_LIST_SUMMARY_IS_FETCHING: "AWARD_LIST_SUMMARY_IS_FETCHING",

	SET_ITEMS: "AWARDS_SET_ITEMS",
	ADD_ITEMS: "AWARDS_ADD_ITEMS",
	SET_SORT: "AWARDS_SET_SORT",
	SET_PAGING: "AWARDS_SET_PAGING",
	RESET: "AWARDS_RESET",
	SET_SEARCH: "AWARDS_SET_SEARCH"
};

export const award = {
	SINGLE_AWARD: "SINGLE_AWARD",
	SINGLE_AWARD_IS_FETCHING: "SINGLE_AWARD_IS_FETCHING",
	SINGLE_AWARD_SET_ERROR: "SINGLE_AWARD_SET_ERROR",
	SINGLE_AWARD_SET_DATA: "SINGLE_AWARD_SET_DATA",
	SINGLE_AWARD_UPDATE_DATA: "SINGLE_AWARD_UPDATE_DATA",

	SINGLE_AWARD_VALUES: "SINGLE_AWARD_VALUES",
	SINGLE_AWARD_VALUES_IS_FETCHING: "SINGLE_AWARD_VALUES_IS_FETCHING",
	SINGLE_AWARD_VALUES_SET_ERROR: "SINGLE_AWARD_VALUES_SET_ERROR",
	SINGLE_AWARD_VALUES_SET_DATA: "SINGLE_AWARD_VALUES_SET_DATA",
	SINGLE_AWARD_VALUES_UPDATE_DATA: "SINGLE_AWARD_VALUES_UPDATE_DATA",

	SINGLE_AWARD_CERTIFICATIONS: "SINGLE_AWARD_CERTIFICATIONS",
	SINGLE_AWARD_CERTIFICATIONS_IS_FETCHING: "SINGLE_AWARD_CERTIFICATIONS_IS_FETCHING",
	SINGLE_AWARD_CERTIFICATIONS_SET_ERROR: "SINGLE_AWARD_CERTIFICATIONS_SET_ERROR",
	SINGLE_AWARD_CERTIFICATIONS_SET_DATA: "SINGLE_AWARD_CERTIFICATIONS_SET_DATA",
	SINGLE_AWARD_CERTIFICATIONS_UPDATE_DATA: "SINGLE_AWARD_CERTIFICATIONS_UPDATE_DATA",

	RESET: "SINGLE_AWARD_RESET",
};

export const subawards = {
	SUBAWARD_LIST: "SUBAWARD_LIST",
	SUBAWARD_LIST_SET_DATA: "SUBAWARD_LIST_SET_DATA",
	SUBAWARD_LIST_SET_ERROR: "SUBAWARD_LIST_SET_ERROR",
	SUBAWARD_LIST_IS_FETCHING: "SUBAWARD_LIST_IS_FETCHING",

	SUBAWARD_LIST_SUMMARY: "SUBAWARD_LIST_SUMMARY",
	SUBAWARD_LIST_SUMMARY_SET_DATA: "SUBAWARD_LIST_SUMMARY_SET_DATA",
	SUBAWARD_LIST_SUMMARY_SET_ERROR: "SUBAWARD_LIST_SUMMARY_SET_ERROR",
	SUBAWARD_LIST_SUMMARY_IS_FETCHING: "SUBAWARD_LIST_SUMMARY_IS_FETCHING",

	SET_ITEMS: "SUBAWARDS_SET_ITEMS",
	ADD_ITEMS: "SUBAWARDS_ADD_ITEMS",
	SET_SORT: "SUBAWARDS_SET_SORT",
	SET_PAGING: "SUBAWARDS_SET_PAGING",
	RESET: "SUBAWARDS_RESET",
	SET_SUMMARY: "SUBAWARDS_SET_SUMMARY",
	SET_SEARCH: "SUBAWARDS_SET_SEARCH"
};

export const subaward = {
	SINGLE_SUBAWARD: "SINGLE_SUBAWARD",
	SINGLE_SUBAWARD_SET_DATA: "SINGLE_SUBAWARD_SET_DATA",
	SINGLE_SUBAWARD_SET_ERROR: "SINGLE_SUBAWARD_SET_ERROR",
	SINGLE_SUBAWARD_IS_FETCHING: "SINGLE_SUBAWARD_IS_FETCHING",

	SINGLE_SUBAWARD_VALUES: "SINGLE_SUBAWARD_VALUES",
	SINGLE_SUBAWARD_VALUES_IS_FETCHING: "SINGLE_SUBAWARD_VALUES_IS_FETCHING",
	SINGLE_SUBAWARD_VALUES_SET_DATA: "SINGLE_SUBAWARD_VALUES_SET_DATA",
	SINGLE_SUBAWARD_VALUES_SET_ERROR: "SINGLE_SUBAWARD_VALUES_SET_ERROR",

	RESET: "SINGLE_SUBAWARD_RESET",
};

export const form = {
	FORM: "FORM",
	FORM_SET_DATA: "FORM_SET_DATA",
	FORM_SET_ERROR: "FORM_SET_ERROR",
	FORM_IS_FETCHING: "FORM_IS_FETCHING",
	FORM_EDIT_MODE: "FORM_EDIT_MODE",
	FORM_EDIT_LOCKED: "FORM_EDIT_LOCKED",
	FORM_TIMEOUT_INFO: "FORM_TIMEOUT_INFO",

	SET_RULES: "FORM_SET_RULES",
	RESET: "FORM_RESET",


	FORM_ENTITY_SET_INDICATOR_IS_SAVING: "FORM_ENTITY_SET_INDICATOR_IS_SAVING",
	FORM_ENTITY: "FORM_ENTITY",
	FORM_ENTITY_SET_DATA: "FORM_ENTITY_SET_DATA",
	FORM_ENTITY_SET_ERROR: "FORM_ENTITY_SET_ERROR",
	FORM_ENTITY_IS_FETCHING: "FORM_ENTITY_IS_FETCHING",
	FORM_ENTITY_SET_ENTITY_CHANGED_FORM_KEYS: "FORM_ENTITY_SET_ENTITY_CHANGED_FORM_KEYS",
	FORM_ENTITY_SET_CONTENT_KEYS: "FORM_ENTITY_SET_CONTENT_KEYS",
	FORM_ENTITY_CHANGED: "FORM_ENTITY_CHANGED",

	SET_ENTITY_FORM_REQUEST_OPTIONS: "SET_ENTITY_FORM_REQUEST_OPTIONS",
	SET_EFFORT_FORMAT: "SET_EFFORT_FORMAT",
	SET_RTO_MEMBER_ASSOCIATION_DETAILS: "SET_RTO_MEMBER_ASSOCIATION_DETAILS",

	FORM_ENTITY_SET_FILE_UPLOADING: "FORM_ENTITY_SET_FILE_UPLOADING",
};

export const groupRoles = {
	GROUP_ROLES: "GROUP_ROLES",
	GROUP_ROLES_SET_DATA: "GROUP_ROLES_SET_DATA",
	GROUP_ROLES_SET_ERROR: "GROUP_ROLES_SET_ERROR",
	GROUP_ROLES_IS_FETCHING: "GROUP_ROLES_IS_FETCHING",
};

export const modifications = {
	MODIFICATIONS: "MODIFICATIONS",
	MODIFICATIONS_SET_DATA: "MODIFICATIONS_SET_DATA",
	MODIFICATIONS_SET_ERROR: "MODIFICATIONS_SET_ERROR",
	MODIFICATIONS_IS_FETCHING: "MODIFICATIONS_IS_FETCHING",

	ADD_ITEMS: "MODIFICATIONS_ADD_ITEMS",
	RESET: "MODIFICATIONS_RESET",
	SET_FILTERS: "MODIFICATIONS_SET_FILTERS",
	SET_ITEMS: "MODIFICATIONS_SET_ITEMS",
	SET_SORT: "MODIFICATIONS_SET_SORT",
	SET_PAGING: "MODIFICATIONS_SET_PAGING",
	SET_SEARCH: "MODIFICATIONS_SET_SEARCH"
};

export const notification = {
	NOTIFY: "NOTIFY"
};

export const picklists = {
	IS_FETCHING: "PICKLISTS_IS_FETCHING",
	SET_ERROR: "PICKLISTS_SET_ERROR",
	SET_CONTENT: "PICKLISTS_SET_CONTENT",
	SET_OPTIONS: "PICKLISTS_SET_OPTIONS"
};

export const project = {
	SINGLE_PROJECT: "SINGLE_PROJECT",
	SINGLE_PROJECT_SET_DATA: "SINGLE_PROJECT_SET_DATA",
	SINGLE_PROJECT_SET_ERROR: "SINGLE_PROJECT_SET_ERROR",
	SINGLE_PROJECT_IS_FETCHING: "SINGLE_PROJECT_IS_FETCHING",
	SINGLE_PROJECT_RESET: "SINGLE_PROJECT_RESET",
};

export const projects = {
	PROJECT_LIST: "PROJECT_LIST",
	PROJECT_LIST_SET_DATA: "PROJECT_LIST_SET_DATA",
	PROJECT_LIST_SET_ERROR: "PROJECT_LIST_SET_ERROR",
	PROJECT_LIST_IS_FETCHING: "PROJECT_LIST_IS_FETCHING",

	PROJECT_LIST_SUMMARY: "PROJECT_LIST_SUMMARY",
	PROJECT_LIST_SUMMARY_SET_DATA: "PROJECT_LIST_SUMMARY_SET_DATA",
	PROJECT_LIST_SUMMARY_SET_ERROR: "PROJECT_LIST_SUMMARY_SET_ERROR",
	PROJECT_LIST_SUMMARY_IS_FETCHING: "PROJECT_LIST_SUMMARY_IS_FETCHING",

	SET_ITEMS: "PROJECTS_SET_ITEMS",
	ADD_ITEMS: "PROJECTS_ADD_ITEMS",
	SET_SORT: "PROJECTS_SET_SORT",
	SET_PAGING: "PROJECTS_SET_PAGING",
	RESET: "PROJECTS_RESET",
	SET_SEARCH: "PROJECTS_SET_SEARCH",
};

export const proposal = {
	SINGLE_PROPOSAL: "SINGLE_PROPOSAL",
	SINGLE_PROPOSAL_IS_FETCHING: "SINGLE_PROPOSAL_IS_FETCHING",
	SINGLE_PROPOSAL_SET_ERROR: "SINGLE_PROPOSAL_SET_ERROR",
	SINGLE_PROPOSAL_SET_DATA: "SINGLE_PROPOSAL_SET_DATA",

	SINGLE_PROPOSAL_VALUES: "SINGLE_PROPOSAL_VALUES",
	SINGLE_PROPOSAL_VALUES_IS_FETCHING: "SINGLE_PROPOSAL_VALUES_IS_FETCHING",
	SINGLE_PROPOSAL_VALUES_SET_DATA: "SINGLE_PROPOSAL_VALUES_SET_DATA",
	SINGLE_PROPOSAL_VALUES_SET_ERROR: "SINGLE_PROPOSAL_VALUES_SET_ERROR",

	SINGLE_PROPOSAL_CERTIFICATIONS: "SINGLE_PROPOSAL_CERTIFICATIONS",
	SINGLE_PROPOSAL_CERTIFICATIONS_IS_FETCHING: "SINGLE_PROPOSAL_CERTIFICATIONS_IS_FETCHING",
	SINGLE_PROPOSAL_CERTIFICATIONS_SET_DATA: "SINGLE_PROPOSAL_CERTIFICATIONS_SET_DATA",
	SINGLE_PROPOSAL_CERTIFICATIONS_SET_ERROR: "SINGLE_PROPOSAL_CERTIFICATIONS_SET_ERROR",


	RESET: "SINGLE_PROPOSAL_RESET"
};

export const budgetBuilder = {
	BUDGET: "BUDGET",
	BUDGET_SET_DATA: "BUDGET_SET_DATA",
	BUDGET_SET_ERROR: "BUDGET_SET_ERROR",
	BUDGET_IS_FETCHING: "BUDGET_IS_FETCHING",
	SET_CURRENT_VERSION: "BUDGET_SET_CURRENT_VERSION",
	RESET: "BUDGET_RESET",
	UPDATE_PERIOD: "BUDGET_UPDATE_PERIOD",
	UPDATE_RESEARCH_TEAM: "BUDGET_UPDATE_RESEARCH_TEAM",
	UPDATE_LINE_ITEMS: "BUDGET_UPDATE_LINE_ITEMS",
};

export const proposals = {
	PROPOSAL_LIST: "PROPOSAL_LIST",
	PROPOSAL_LIST_SET_DATA: "PROPOSAL_LIST_SET_DATA",
	PROPOSAL_LIST_SET_ERROR: "PROPOSAL_LIST_SET_ERROR",
	PROPOSAL_LIST_IS_FETCHING: "PROPOSAL_LIST_IS_FETCHING",

	PROPOSAL_SUMMARY: "PROPOSAL_SUMMARY",
	PROPOSAL_SUMMARY_SET_DATA: "PROPOSAL_SUMMARY_SET_DATA",
	PROPOSAL_SUMMARY_SET_ERROR: "PROPOSAL_SUMMARY_SET_ERROR",
	PROPOSAL_SUMMARY_IS_FETCHING: "PROPOSAL_SUMMARY_IS_FETCHING",

	SET_ITEMS: "PROPOSALS_SET_ITEMS",
	ADD_ITEMS: "PROPOSALS_ADD_ITEMS",
	SET_SORT: "PROPOSALS_SET_SORT",
	SET_PAGING: "PROPOSALS_SET_PAGING",
	RESET: "PROPOSALS_RESET",
	SET_SEARCH: "PROPOSALS_SET_SEARCH"
};

export const shell = {
	SHELL: "SHELL",
	SHELL_SET_DATA: "SHELL_SET_DATA",
	SHELL_SET_ERROR: "SHELL_SET_ERROR",
	SHELL_IS_FETCHING: "SHELL_IS_FETCHING",

	FETCH_USER_TASKS: "SHELL_FETCH_USER_TASKS",
	RESET: "SHELL_RESET",
	SET_CAYUSE_HEADER: "SHELL_SET_CAYUSE_HEADER",
	SET_USER_PRIVILEGES: "SHELL_SET_USER_PRIVILEGES"
};

export const task = {
	IS_FETCHING: "SINGLE_TASK_IS_FETCHING",
	SET_ERROR: "SINGLE_TASK_SET_ERROR",
	SET_CONTENT: "SINGLE_TASK_SET_CONTENT",
	RESET: "SINGLE_TASK_RESET"
};

export const tasks = {
	ALL_TASKS: "ALL_TASKS",
	ALL_TASKS_IS_FETCHING: "ALL_TASKS_IS_FETCHING",
	ALL_TASKS_SET_ERROR: "ALL_TASKS_SET_ERROR",
	ALL_TASKS_SET_DATA: "ALL_TASKS_SET_DATA",

	RESET: "TASKS_RESET",
	SET_FILTERS: "TASKS_SET_FILTERS",

	SET_SORT: "TASKS_SET_SORT",
	SET_PAGING: "TASKS_SET_PAGING",

	AWARD_TASKS: "AWARD_TASKS",
	AWARD_TASKS_IS_FETCHING: "AWARD_TASKS_IS_FETCHING",
	AWARD_TASKS_SET_DATA: "AWARD_TASKS_SET_DATA",
	AWARD_TASKS_SET_ERROR: "AWARD_TASKS_SET_ERROR",

	PROPOSAL_TASKS: "PROPOSAL_TASKS",
	PROPOSAL_TASKS_IS_FETCHING: "PROPOSAL_TASKS_IS_FETCHING",
	PROPOSAL_TASKS_SET_DATA: "PROPOSAL_TASKS_SET_DATA",
	PROPOSAL_TASKS_SET_ERROR: "PROPOSAL_TASKS_SET_ERROR",

	CERTIFICATION_IS_FETCHING: "CERTIFICATION_IS_FETCHING",
};

export const tenant = {
	TENANT: "TENANT",
	TENANT_SET_DATA: "TENANT_SET_DATA",
	TENANT_SET_ERROR: "TENANT_SET_ERROR",
	TENANT_IS_FETCHING: "TENANT_IS_FETCHING",
	SET_CERTIFICATION_TEXT: "TENANT_SET_CERTIFICATION_TEXT"
};

export const researchRoles = {
	RESEARCH_ROLES: "RESEARCH_ROLES",
	RESEARCH_ROLES_SET_DATA: "RESEARCH_ROLES_SET_DATA",
	RESEARCH_ROLES_SET_CHANGED_DATA: "RESEARCH_ROLES_SET_CHANGED_DATA",
	RESEARCH_ROLES_SET_WAS_CHANGED: "RESEARCH_ROLES_SET_WAS_CHANGED",
	RESEARCH_ROLES_SET_ERROR: "RESEARCH_ROLES_SET_ERROR",
	RESEARCH_ROLES_IS_FETCHING: "RESEARCH_ROLES_IS_FETCHING",
};

export const userAccesses = {
	USER_ACCESSES: "USER_ACCESSES",
	USER_ACCESSES_IS_FETCHING: "USER_ACCESSES_IS_FETCHING",
	USER_ACCESSES_SET_ERROR: "USER_ACCESSES_SET_ERROR",
	USER_ACCESSES_SET_DATA: "USER_ACCESSES_SET_DATA",
	USER_ACCESSES_RESET: "USER_ACCESSES_RESET"
};

export const userTasks = {
	USER_TASKS: "USER_TASKS",
	USER_TASKS_SET_DATA: "USER_TASKS_SET_DATA",
	USER_TASKS_SET_ERROR: "USER_TASKS_SET_ERROR",
	USER_TASKS_IS_FETCHING: "USER_TASKS_IS_FETCHING",

	RESET: "USER_TASKS_RESET"
};

export const facetedSearch = {
	SET_PROPOSAL_LIST_FACETED_SEARCH_KEYS: "SET_PROPOSAL_LIST_FACETED_SEARCH_KEYS",
	SET_PROPOSAL_LIST_ACTUAL_FACETS: "SET_PROPOSAL_LIST_ACTUAL_FACETS",
	SET_AWARD_LIST_FACETED_SEARCH_KEYS: "SET_AWARD_LIST_FACETED_SEARCH_KEYS",
	SET_AWARD_LIST_ACTUAL_FACETS: "SET_AWARD_LIST_ACTUAL_FACETS",
	SET_PROJECT_LIST_FACETED_SEARCH_KEYS: "SET_PROJECT_LIST_FACETED_SEARCH_KEYS",
	SET_PROJECT_LIST_ACTUAL_FACETS: "SET_PROJECT_LIST_ACTUAL_FACETS",
};

export const columns = {
	AWARDS_SET_ACTIVE_COLS: "AWARDS_SET_ACTIVE_COLS",
	AWARDS_SET_AVAILABLE_COLS: "AWARDS_SET_AVAILABLE_COLS",

	PROJECTS_SET_ACTIVE_COLS: "PROJECTS_SET_ACTIVE_COLS",
	PROJECTS_SET_AVAILABLE_COLS: "PROJECTS_SET_AVAILABLE_COLS",

	PROPOSALS_SET_ACTIVE_COLS: "PROPOSALS_SET_ACTIVE_COLS",
	PROPOSALS_SET_AVAILABLE_COLS: "PROPOSALS_SET_AVAILABLE_COLS",

	SUBAWARDS_SET_ACTIVE_COLS: "SUBAWARDS_SET_ACTIVE_COLS",
	SUBAWARDS_SET_AVAILABLE_COLS: "SUBAWARDS_SET_AVAILABLE_COLS",

	MODIFICATIONS_SET_ACTIVE_COLS: "MODIFICATIONS_SET_ACTIVE_COLS",
	SUBAWARDS_MODIFICATIONS_SET_ACTIVE_COLS: "SUBAWARDS_MODIFICATIONS_SET_ACTIVE_COLS",

	TASKS_SET_ACTIVE_COLS: "TASKS_SET_ACTIVE_COLS"
};

export default {
	groupRoles,
	notification,
	projects,
	proposals,
	shell,
	task,
	tasks,
	tenant,
	userTasks,
	facetedSearch,
	columns,
};
